import { Translatable, TranslateProperty } from '../../../core/helper/translatables';
import { ModelBase } from '../../../core/model/model-base';
import { B2CSubscriptionState, B2CSubscriptionStateToString } from '../const/enum-b2c';
import { B2CSubscriptionIdentity } from './b2c-subscription-identity';

export class B2CSubscriptionSuggestion extends ModelBase {
  constructor() {
    super();
    TranslateProperty(this as B2CSubscriptionSuggestion, 'state', B2CSubscriptionStateToString);
  }

  identity: B2CSubscriptionIdentity;

  state: Translatable<B2CSubscriptionState>;
  stateChangedDate: Date;

  toString(culture?: string): string {
    return this.identity.toString(culture);
  }

  public static Map(source: B2CSubscriptionSuggestion): B2CSubscriptionSuggestion {
    if (!source) {
      return null;
    }
    const obj = Object.assign(new B2CSubscriptionSuggestion(), source);
    obj.identity = B2CSubscriptionIdentity.Map(source.identity);
    return obj;
  }
}
